import * as React from 'react';
import { IMyHomeLayoutProps } from '../../types/myHomeForm';

import cn from 'clsx';
import * as styles from '../shared_my_home_styles.css';

import { Label } from '../../../common/packages/Label';
import { FilterWithButtonGroup } from '../../../common/packages/FilterWithButtonGroup';
import { AddressInput } from '../../../common/packages/AddressInput';
import { RoomNumberInput } from '../../../common/packages/RoomNumberInput';
import { RoomsCountSelector } from '../../../common/packages/RoomsCountSelector';
import { AreaInput } from '../../../common/packages/AreaInput';
import { SwitchComponent } from '../../../common/packages/Switch';
import { UIText1, UIText2 } from '@cian/ui-kit';

export const FlatComponent: React.FC<IMyHomeLayoutProps> = props => {
  return (
    <div className={styles['container']}>
      <form className={styles['form-content']} onSubmit={(e: React.FormEvent) => e.preventDefault()}>
        <div className={styles['form-content-item']}>
          <Label label="Тип недвижимости" />
          <FilterWithButtonGroup {...props.estimationTargetProps} testId="my_home_estimation_target_control" />
        </div>

        <div className={cn(styles['form-content-item'], styles['form-content-room-number-items'])}>
          <div>
            <Label label="Адрес" />
            <AddressInput className={styles['form-content-fixed-height']} {...props.addressProps} />
          </div>

          <div className={styles['form-content-flat-number']}>
            <Label label="Квартира" />
            <RoomNumberInput {...props.roomNumberProps} />
          </div>
        </div>

        {props.roomNumberProps.isRoomSuggestSuccess && (
          <div className={cn(styles['form-content-item'], styles['form-content-flat-items'])}>
            <div>
              <Label label="Количество комнат" />
              <RoomsCountSelector className={styles['form-content-fixed-height']} {...props.roomsCountSelectorProps} />
            </div>

            <div className={styles['form-content-area-item']}>
              <Label label="Площадь" />
              <AreaInput {...props.areaProps} />
            </div>
          </div>
        )}

        <div className={cn(styles['form-content-item'], styles['form-content-subscribe-item'])}>
          <div>
            <UIText1 color="black_100">Получать обновления цены</UIText1>
            <UIText2 color="gray60_100">Раз месяц будем рассказывать об изменениях на рынке</UIText2>
          </div>

          <div>
            <SwitchComponent {...props.switchProps} />
          </div>
        </div>
      </form>
    </div>
  );
};
